export enum NutritionalChoice {
  SmartReco = 'SmartReco',
  DailyAllowance = 'DailyAllowance',
}
